import BoardScreen from '@screens/Board/BoardScreen';

export default BoardScreen;
